<script lang="ts">
  import { page } from '$app/state';
</script>

<main class="container py-3" id="main-container">
  <div class="py-5">
    <div class="row">
      <div class="col col-md-8 col-lg-6 mx-auto">
        <div class="card">
          <div class="card-header"><h1 class="mb-0">{page.status} {page.error?.message}</h1></div>
          <div class="card-body">
            <p>{page.error?.message}</p>
            <div class="d-grid">
              <a href="/" class="btn btn-primary">Home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
